/* ==========================================================================
   OSERE — «Qué es CoreN°1»: los puntos encienden la foto

   QUÉ HACE ESTE ARCHIVO Y QUÉ NO.

   El estado inicial lo pinta Liquid: la primera figura sale del servidor con
   `data-activa` y el primer botón con `aria-pressed="true"`. Este archivo solo
   MUEVE cuál está encendida. Si no llega a ejecutarse —bloqueado, error de
   red, navegador viejo— se ve la primera foto y los cuatro textos se leen
   enteros, porque nunca se ocultan.

   Es el mismo criterio que el pie y que el vídeo del hero: la mejora se añade,
   nunca se resta de algo que ya funciona.

   En escritorio también responde al puntero: pasar por encima enciende, que es
   más rápido que obligar a hacer clic. En táctil `pointerenter` no dispara por
   sí solo, así que el clic sigue siendo el camino real.
   ========================================================================== */

(function () {
  'use strict';

  function montar(seccion) {
    var botones = seccion.querySelectorAll('[data-os-punto]');
    var figuras = seccion.querySelectorAll('[data-os-figura]');
    if (botones.length < 2 || figuras.length < 2) return;

    function encender(i) {
      Array.prototype.forEach.call(botones, function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-os-punto') === i ? 'true' : 'false');
      });
      Array.prototype.forEach.call(figuras, function (f) {
        if (f.getAttribute('data-os-figura') === i) {
          f.setAttribute('data-activa', '');
          /* La foto se pidió con `loading="lazy"`. Al encenderla se fuerza su
             carga para que no se vea entrar cuando ya debería estar. */
          var img = f.querySelector('img');
          if (img && img.loading === 'lazy') img.loading = 'eager';
        } else {
          f.removeAttribute('data-activa');
        }
      });
    }

    Array.prototype.forEach.call(botones, function (b) {
      var i = b.getAttribute('data-os-punto');

      b.addEventListener('click', function () { encender(i); });

      /* Solo con ratón o lápiz. En táctil el navegador sintetiza un
         `pointerenter` justo antes del clic y encendería dos veces. */
      b.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'touch') return;
        encender(i);
      });

      /* Llegar por tabulador también enciende: quien navega con teclado ve la
         foto sin tener que pulsar, igual que quien pasa el ratón. */
      b.addEventListener('focus', function () { encender(i); });
    });

    /* Flechas para moverse entre puntos, como en cualquier grupo de controles
       relacionados. Sin esto el teclado funciona, pero de uno en uno. */
    seccion.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var actual = document.activeElement;
      if (!actual || !actual.hasAttribute('data-os-punto')) return;
      e.preventDefault();
      var lista = Array.prototype.slice.call(botones);
      var pos = lista.indexOf(actual);
      var siguiente = e.key === 'ArrowDown'
        ? (pos + 1) % lista.length
        : (pos - 1 + lista.length) % lista.length;
      lista[siguiente].focus();
    });
  }

  function init() {
    var secciones = document.querySelectorAll('[data-os-que-es]');
    Array.prototype.forEach.call(secciones, montar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  /* El personalizador reconstruye la sección al editarla y se lleva por delante
     los listeners. Shopify avisa con este evento; sin esto, la interacción deja
     de funcionar en el editor y parece rota justo cuando la clienta la mira. */
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-os-que-es]');
    if (s) montar(s);
  });
})();
